import { render, staticRenderFns } from "./AddDoctor.vue?vue&type=template&id=2662cb50&"
import script from "./AddDoctor.vue?vue&type=script&lang=js&"
export * from "./AddDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports